export default "__VITE_ASSET__BumF7nrT__"